<template>
	<v-sheet>
		<v-text-field v-model="excelTemplate.name" label="帳票名(必須)" class="mt-4" type="text" :rules="[rules.required]" required dense outlined />
		<v-select
			v-model="excelTemplate.base_model"
			label="参照データ(必須)"
			:items="modelNames"
			class="mt-4"
			item-text="name"
			item-value="id"
			:rules="disabledBaseModelSelect ? [] : [rules.required]"
			required
			dense
			outlined
			:disabled="disabledBaseModelSelect"
			:hint="disabledBaseModelSelect ? '参照データは変更できません。' : '帳票のベースとなるデータです。'"
			:persistent-hint="disabledBaseModelSelect"
		/>
		<v-select
			v-model="excelTemplate.department_id"
			label="部門"
			:items="departments"
			class="mt-4"
			item-text="name"
			item-value="id"
			required
			dense
			clearable
			outlined
		/>
		<v-file-input
			v-if="showFileInput"
			v-model="file"
			label="テンプレートとなるエクセルファイル(必須)"
			accept=".xlsx"
			class="mt-4"
			prepend-icon=""
			:rules="showFileInput ? [rules.required] : []"
			required
			dense
			outlined
			@change="changeImage(file)"
		/>
		<v-checkbox v-model="excelTemplate.exclusive_flag" class="mt-4 shrink" label="自身専用の帳票" dense />
	</v-sheet>
</template>

<script>
import rules from "../../../helper/rules"

export default {
	props: {
		excel_template: {
			type: Object,
			required: true,
			default: {
				name: {
					type: String,
					required: true,
				},
				base_model: {
					type: String,
					required: true,
				},
				exclusive_flag: {
					type: Boolean,
					required: true,
				},
				department_id: {
					type: Number,
					required: true,
				},
				file: {
					type: Object,
					required: false,
				},
			},
		},
		modelNames: {
			type: Array,
			required: true,
			default: () => [
				{
					id: {
						type: Number,
						required: true,
					},
					name: {
						type: String,
						required: true,
					},
				},
			],
		},
		departments: {
			type: Array,
			required: true,
			default: () => [
				{
					id: {
						type: Number,
						required: true,
					},
					name: {
						type: String,
						required: true,
					},
				},
			],
		},
		showFileInput: {
			type: Boolean,
			required: false,
			default: false,
		},
		disabledBaseModelSelect: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
	data() {
		return {
			rules: rules,
			file: null,
		}
	},
	methods: {
		changeImage(file) {
			if (file == null) {
				this.excelTemplate.file = null
				return
			}
			var fileData = new Object()
			fileData.type = file.type
			fileData.fileName = file.name
			this.readFileAsync(file)
				.then((res) => {
					fileData.data = res
					this.excelTemplate.file = fileData
				})
				.catch((e) => {
					this.$store.commit("setFlash", {
						type: "alert",
						text: "ファイルの読み込みに失敗しました",
					})
				})
		},
		readFileAsync(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader()
				reader.onload = () => {
					resolve(reader.result)
				}
				reader.onerror = reject
				reader.readAsArrayBuffer(file)
			})
		},
	},
	computed: {
		excelTemplate: {
			get() {
				return this.excel_template
			},
			set(newVal) {
				return this.$emit("update:excel_template", newVal)
			},
		},
	},
}
</script>